/*
 * DOMICILIO KONG — entrega local en Cuernavaca (Uber Moto).
 *
 * Una sola fuente de verdad: assets/kong-zonas.json, generado por
 * WEB KONG/entrega-local/2-zonas.js (las mismas listas de CP que están en
 * Shopify → Entrega local). El checkout valida con el CP real; aquí solo
 * se informa, se elige horario y se capturan los datos de quien recibe.
 *
 * Componentes:
 *   <kong-domicilio>   carrito (drawer y página): modo, CP, día, horario, quién recibe.
 *   <kong-radar-mini>  página de producto: “¿te llega gratis?”.
 *   <kong-radar>       página /pages/envios: mapa + radar + GPS.
 *
 * Los datos van en atributos del carrito (salen en el pedido). Solo
 * bloquea el botón de pago lo que él mismo marcó (data-kd-disabled), igual
 * que landerlan-usa-min.js, para no pisar otras reglas.
 */
(function () {
  'use strict';
  if (window.KongDomicilio) return;

  var TZ = 'America/Mexico_City';
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var DIAS_C = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var ATTR = {
    entrega: 'Entrega',
    cp: 'CP de entrega',
    dia: 'Día de entrega',
    horario: 'Horario de entrega',
    recibe: 'Recibe',
    cel: 'Celular de quien recibe',
    ref: 'Referencias',
    col: 'Colonia de entrega',
    mun: 'Municipio de entrega',
    slot: '_kd_slot'
  };
  var CHECKOUT_IDS = ['checkout', 'CartDrawer-Checkout'];
  var FORM_IDS = ['cart', 'CartDrawer-Form'];

  /* ---------- utilidades ---------- */
  var ls = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(pesos) {
    return '$' + Math.round(pesos).toLocaleString('es-MX');
  }
  function cfgOf(el) {
    try { return JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { return {}; }
  }
  function cpValido(cp) { return /^\d{5}$/.test(cp || ''); }
  function celValido(c) { return /^\d{10}$/.test((c || '').replace(/\D/g, '')); }
  function km(a, b) {
    var R = 6371, r = Math.PI / 180;
    var dl = (b[0] - a[0]) * r, dn = (b[1] - a[1]) * r;
    var h = Math.sin(dl / 2) * Math.sin(dl / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dn / 2) * Math.sin(dn / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  /* ---------- zonas ---------- */
  var zonasPromise = null;
  function cargarZonas(url) {
    if (!zonasPromise) {
      zonasPromise = fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('zonas ' + r.status); return r.json(); })
        .catch(function (e) { zonasPromise = null; throw e; });
    }
    return zonasPromise;
  }
  function buscarCP(Z, cp) {
    var r = Z.cp[cp];
    if (!r) return { cp: cp, zona: 'nacional' };
    return { cp: cp, zona: r[0] === 0 ? 'gratis' : 'z50', lat: r[1], lon: r[2], nombre: r[3] };
  }
  /* ---------- colonia ↔ CP ↔ municipio ---------- */
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function municipioDe(Z, cp) { var m = Z.mun && Z.mun[cp]; return m ? Z.muns[m[0]] : null; }
  function zonaDe(Z, cp) { var m = Z.mun && Z.mun[cp]; return m ? ['gratis', 'z50', 'nacional'][m[1]] : 'nacional'; }
  function textoZona(Z, zona) {
    return zona === 'gratis' ? 'el domicilio es <b>GRATIS</b>' : zona === 'z50' ? 'el domicilio cuesta <b>' + money(Z.precio50) + '</b>' : 'no hay domicilio: te llega por envío nacional <b>' + money(Z.nacional) + '</b>';
  }
  // Colonias que coinciden con lo que escribe el cliente; primero las de su CP y su municipio.
  function buscarColonias(Z, q, cp) {
    var n = norm(q);
    if (n.length < 2) return [];
    var mun = municipioDe(Z, cp);
    var res = [];
    (Z.col || []).forEach(function (e) {
      var en = norm(e[0]), i = en.indexOf(n);
      if (i === -1) return;
      var score = (i === 0 ? 0 : 10) + (e[1] === cp ? 0 : municipioDe(Z, e[1]) === mun ? 3 : 6);
      res.push({ nombre: e[0], cp: e[1], mun: municipioDe(Z, e[1]), zona: zonaDe(Z, e[1]), score: score });
    });
    res.sort(function (a, b) { return a.score - b.score || a.nombre.localeCompare(b.nombre, 'es'); });
    return res.slice(0, 8);
  }
  // Revisa que la colonia corresponda al CP. Devuelve {estado:'sin'|'ok'|'libre'|'choque', opciones:[...]}.
  function coherencia(Z, cp, col, colCp) {
    if (!col || !col.trim()) return { estado: 'sin' };
    if (colCp) return colCp === cp ? { estado: 'ok' } : { estado: 'choque', opciones: [{ nombre: col, cp: colCp, mun: municipioDe(Z, colCp), zona: zonaDe(Z, colCp) }] };
    var n = norm(col);
    var iguales = (Z.col || []).filter(function (e) { return norm(e[0]) === n; });
    if (!iguales.length) return { estado: 'libre' };
    if (iguales.some(function (e) { return e[1] === cp; })) return { estado: 'ok' };
    return { estado: 'choque', opciones: iguales.map(function (e) { return { nombre: e[0], cp: e[1], mun: municipioDe(Z, e[1]), zona: zonaDe(Z, e[1]) }; }) };
  }

  function precioZona(Z, zona) { return zona === 'gratis' ? 0 : zona === 'z50' ? Z.precio50 : Z.nacional; }
  function cpMasCercano(Z, lat, lon) {
    var best = null;
    Object.keys(Z.cp).forEach(function (cp) {
      var r = Z.cp[cp];
      if (r[1] == null) return;
      var d = km([lat, lon], [r[1], r[2]]);
      if (!best || d < best.d) best = { cp: cp, d: d };
    });
    return best;
  }

  /* ---------- horarios (siempre en hora de Cuernavaca) ---------- */
  function ahoraMx() {
    var p = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var g = function (t) { for (var i = 0; i < p.length; i++) if (p[i].type === t) return +p[i].value; return 0; };
    return { y: g('year'), m: g('month'), d: g('day'), min: (g('hour') % 24) * 60 + g('minute') };
  }
  function rango(txt) {
    var m = /^\s*(\d{1,2})(?::(\d{2}))?\s*-\s*(\d{1,2})(?::(\d{2}))?\s*$/.exec(txt || '');
    if (!m) return null;
    var a = +m[1] * 60 + (+m[2] || 0), b = +m[3] * 60 + (+m[4] || 0);
    return b > a ? [a, b] : null;
  }
  function hhmm(min) {
    var h = Math.floor(min / 60), m = min % 60, ap = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
  }
  // "9:30" sin am/pm: el grupo (Mañana/Tarde/Noche) ya lo dice.
  function horaCorta(min) {
    var hh = Math.floor(min / 60) % 12 || 12, mm = min % 60;
    return hh + ':' + (mm < 10 ? '0' : '') + mm;
  }
  function iso(y, m, d) { return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d; }

  /* Devuelve [{key:'2026-10-17', label, largo, slots:[{key, sale, desde, hasta, texto}]}] */
  function agenda(cfg) {
    var now = ahoraMx();
    var porDia = { 0: rango(cfg.dom), 6: rango(cfg.sab) };
    var lv = rango(cfg.lv);
    for (var w = 1; w <= 5; w++) porDia[w] = lv;
    var ultima = +cfg.ultima || 60, acepta = +cfg.acepta || 30, ventana = +cfg.ventana || 60, prep = +cfg.prep || 30;
    var sin = String(cfg.sin || '').split(/[\s,]+/).filter(Boolean);
    var pausa = (cfg.pausa || '').trim();
    var out = [];
    for (var i = 0; i < 14 && out.length < 7; i++) {
      var dt = new Date(Date.UTC(now.y, now.m - 1, now.d + i));
      var y = dt.getUTCFullYear(), mo = dt.getUTCMonth() + 1, d = dt.getUTCDate(), wd = dt.getUTCDay();
      var key = iso(y, mo, d);
      if (sin.indexOf(key) !== -1) continue;
      if (pausa && key <= pausa) continue;
      var r = porDia[wd];
      if (!r) continue;
      var slots = [];
      for (var t = r[0]; t <= r[1] - ultima; t += 60) {
        if (i === 0 && t < now.min + prep) continue;
        var a = t + acepta, b = a + ventana;
        slots.push({ key: key + 'T' + Math.floor(t / 60) + ':' + (t % 60 < 10 ? '0' : '') + (t % 60), sale: t, desde: a, hasta: b, texto: hhmm(a) + ' – ' + hhmm(b) });
      }
      if (!slots.length) continue;
      out.push({
        key: key,
        label: i === 0 ? 'Hoy' : i === 1 ? 'Mañana' : DIAS_C[wd] + ' ' + d,
        largo: DIAS[wd] + ' ' + d + ' de ' + MESES[mo - 1],
        slots: slots
      });
    }
    return out;
  }

  /* ---------- carrito ---------- */
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function guardarAtributos(attrs) {
    return fetch(cartRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  // Estado compartido entre re-renders del carrito (el drawer reemplaza su HTML en cada cambio).
  var S = window.__kdState || (window.__kdState = { mode: null, cp: null, slot: null, recibe: '', cel: '', ref: '', col: '', colCp: null, dirty: false, saving: null, hydrated: false });

  // Qué le falta al cliente para pagar (texto corto para la barra del celular y el mensaje rojo).
  function faltantes(c) {
    if (!S.mode) return ['cómo lo recibes'];
    if (S.mode !== 'domicilio' || !c) return [];
    if (!(S.cp && cpValido(S.cp))) return ['tu código postal'];
    if (!c.elegible) return [];
    var f = [];
    if (c.coh && c.coh.estado === 'sin') f.push('tu colonia');
    if (c.coh && c.coh.estado === 'choque') f.push('corregir CP o colonia');
    if (!S.slot) f.push('el horario');
    if (S.recibe.trim().length < 3) f.push('quién recibe');
    if (!celValido(S.cel)) f.push('celular de 10 dígitos');
    return f;
  }

  // El botón de pago NO se deshabilita: deshabilitado, el clic no hace nada y el cliente no sabe por qué.
  // Se marca con aria-disabled y el submit muestra qué falta y lleva al campo.
  // Cada selector solo manda en SUS botones: en /cart también existe el carrito lateral (escondido) con su
  // propia copia del selector, y antes esa copia vieja bloqueaba el botón de la página sin que se viera por qué.
  function sincronizarBotones(bloquear, ctx, el) {
    var drawer = el && el.closest ? el.closest('cart-drawer') : null;
    var root = drawer || (el ? document.getElementById('main-cart-footer') : null) || document;
    var ids = !el ? CHECKOUT_IDS : drawer ? ['CartDrawer-Checkout'] : ['checkout'];
    // Los botones exprés del carrito (Shop Pay, etc.) también se brincaban el candado: se ocultan mientras falte algo.
    root.querySelectorAll('.cart__dynamic-checkout-buttons, #dynamic-checkout-cart').forEach(function (b) {
      if (bloquear) b.style.setProperty('display', 'none', 'important');
      else b.style.removeProperty('display');
    });
    ids.forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      // Limpieza de la versión anterior, que sí ponía disabled.
      if (btn.getAttribute('data-kd-disabled') === 'true') {
        btn.removeAttribute('data-kd-disabled');
        if (btn.getAttribute('data-ll-usa-disabled') !== 'true') btn.removeAttribute('disabled');
      }
      btn.classList.toggle('kd-bloqueado', !!bloquear);
      if (bloquear) btn.setAttribute('aria-disabled', 'true');
      else if (btn.getAttribute('data-ll-usa-disabled') !== 'true') btn.removeAttribute('aria-disabled');
    });
    if (!drawer) {
      var bb = document.getElementById('kcart-bar-btn');
      if (bb) bb.classList.toggle('kd-bloqueado', !!bloquear);
    }
    var f = bloquear ? faltantes(ctx) : [];
    var txt = f.length ? 'Falta: ' + f.join(', ') : '';
    root.querySelectorAll('[data-kd-falta]').forEach(function (n) { n.textContent = txt; n.hidden = !txt; });
  }

  var guardTimer = null;
  function programarGuardado(el) {
    S.dirty = true;
    clearTimeout(guardTimer);
    guardTimer = setTimeout(function () { flush(el); }, 450);
  }
  function atributosActuales(el) {
    var c = el && el._ctx;
    var activo = S.mode === 'domicilio' && c && c.elegible;
    if (!activo) {
      var vacio = {};
      Object.keys(ATTR).forEach(function (k) { vacio[ATTR[k]] = ''; });
      return vacio;
    }
    var dia = null, slot = null;
    (c.agenda || []).forEach(function (d) { d.slots.forEach(function (s) { if (s.key === S.slot) { dia = d; slot = s; } }); });
    var o = {};
    o[ATTR.entrega] = 'Domicilio Kong · ' + (c.info.zona === 'gratis' ? 'GRATIS' : money(c.Z.precio50));
    o[ATTR.cp] = S.cp;
    o[ATTR.dia] = dia ? dia.largo : '';
    o[ATTR.horario] = slot ? 'llega aprox. ' + slot.texto + ' (sale ' + hhmm(slot.sale) + ')' : '';
    o[ATTR.slot] = slot ? slot.key : '';
    o[ATTR.recibe] = S.recibe.trim();
    o[ATTR.cel] = S.cel.replace(/\D/g, '');
    o[ATTR.ref] = S.ref.trim();
    o[ATTR.col] = S.col.trim() + (c.coh && c.coh.estado === 'libre' ? ' (no verificada)' : '');
    o[ATTR.mun] = municipioDe(c.Z, S.cp) || '';
    return o;
  }
  /* Propiedad visible en la PRIMERA línea del carrito. En Basic no se puede
     poner nada propio dentro del checkout, pero las propiedades de línea sí se
     muestran ahí (debajo del producto), en el correo de confirmación, en el
     pedido del admin y en el packing slip. */
  var PROP = '🛵 Entrega a domicilio';
  function propiedadActual(el) {
    var c = el && el._ctx;
    if (S.mode !== 'domicilio' || !c || !c.elegible || !c.completo) return '';
    var dia = null, slot = null;
    (c.agenda || []).forEach(function (d) { d.slots.forEach(function (s) { if (s.key === S.slot) { dia = d; slot = s; } }); });
    if (!dia || !slot) return '';
    var lugar = (S.col.trim() ? S.col.trim() + ', ' : '') + 'CP ' + S.cp;
    return dia.largo + ', llega aprox. ' + slot.texto + ' · Recibe: ' + S.recibe.trim() + ' · ' + lugar;
  }
  function sincronizarPropiedad(texto, cart) {
    var pasos = 0;
    function paso(cart) {
      if (!cart || !cart.items || !cart.items.length || pasos++ > 4) return cart;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i], props = it.properties || {};
        var quiero = i === 0 && texto ? texto : null;
        if ((props[PROP] || null) === quiero) continue;
        var np = {};
        Object.keys(props).forEach(function (k) { if (k !== PROP && props[k] != null) np[k] = props[k]; });
        // Shopify ignora un objeto sin la llave: para "quitarla" se manda vacía (el checkout no muestra propiedades vacías).
        np[PROP] = quiero || '';
        return fetch(cartRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: i + 1, quantity: it.quantity, properties: np })
        }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }).then(paso);
      }
      return cart;
    }
    return Promise.resolve(paso(cart));
  }
  // Tras cada re-render del carrito (se quitó o agregó un producto) se revisa que la propiedad siga en la primera línea.
  var revisarTimer = null;
  function programarRevision(el) {
    clearTimeout(revisarTimer);
    revisarTimer = setTimeout(function () {
      revisarTimer = null;
      if (S.dirty || S.saving) return;
      var texto = propiedadActual(el && el._ctx ? el : widgetActivo());
      var p = fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function (cart) { return sincronizarPropiedad(texto, cart); })
        .catch(function () {});
      var sv = p.then(function () { if (S.saving === sv) S.saving = null; });
      S.saving = sv;
    }, 700);
  }

  function flush(el) {
    clearTimeout(guardTimer);
    if (!S.dirty) return S.saving || Promise.resolve();
    S.dirty = false;
    var w = el && el._ctx ? el : widgetActivo();
    var attrs = atributosActuales(w);
    var texto = propiedadActual(w);
    // Los atributos se reintentan una vez (un 429 suele pasar en segundos). La propiedad de línea es un extra:
    // si falla no marca nada pendiente, para que nunca deje el pago esperando.
    var p = guardarAtributos(attrs)
      .catch(function () { return espera(900).then(function () { return guardarAtributos(attrs); }); })
      .then(function (cart) { return sincronizarPropiedad(texto, cart).catch(function () {}); }, function () { S.dirty = true; });
    var sv = p.then(function () { if (S.saving === sv) S.saving = null; });
    S.saving = sv;
    return sv;
  }

  // El selector que el cliente está usando: el del carrito lateral solo si está abierto; si no, el de la página.
  // (El drawer cerrado tiene offsetParent, así que "visible" no sirve para distinguirlos.)
  function widgetActivo() {
    var drawer = document.querySelector('cart-drawer');
    var dra = drawer && drawer.querySelector('kong-domicilio');
    var pag = document.querySelector('#main-cart-footer kong-domicilio');
    var orden = drawer && drawer.classList.contains('active') ? [dra, pag] : [pag, dra];
    for (var i = 0; i < orden.length; i++) if (orden[i] && orden[i]._ctx) return orden[i];
    var all = document.querySelectorAll('kong-domicilio');
    for (var j = 0; j < all.length; j++) if (all[j]._ctx) return all[j];
    return null;
  }
  // El selector que va con el formulario que se está enviando.
  function widgetDe(form) {
    var scope = form && form.id === 'CartDrawer-Form' ? document.querySelector('cart-drawer') : document.getElementById('main-cart-footer');
    var w = scope && scope.querySelector('kong-domicilio');
    return w && w._ctx ? w : widgetActivo();
  }

  function espera(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }

  // Va al pago conservando name="checkout" (sin él Shopify regresa a /cart en vez de ir al checkout).
  function enviar(form, submitter) {
    form.dataset.kdEnviando = '1';
    setTimeout(function () { form.dataset.kdEnviando = ''; }, 6000);
    if (form.requestSubmit && submitter && submitter.form === form) { form.requestSubmit(submitter); return; }
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
    form.appendChild(h);
    form.submit();
  }
  function marcarGuardando(on) {
    CHECKOUT_IDS.concat(['kcart-bar-btn']).forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.classList.toggle('kd-guardando', !!on);
    });
  }

  function protegerFormularios() {
    FORM_IDS.forEach(function (id) {
      var form = document.getElementById(id);
      if (!form || form.dataset.kdGuarded === 'true') return;
      form.dataset.kdGuarded = 'true';
      form.addEventListener('submit', function (e) {
        if (form.dataset.kdEnviando === '1') return; // ya se guardó: dejar pasar al pago
        var el = widgetDe(form);
        if (!el || !el._ctx) return;
        // Estado fresco: el otro selector pudo cambiar datos compartidos.
        el._ctx = el.contexto();
        if (el._ctx.bloqueo) {
          el.render();
          e.preventDefault();
          e.stopImmediatePropagation();
          el.mostrarFaltantes();
          return;
        }
        if (S.dirty || S.saving || revisarTimer) {
          // Un solo intento de guardar horario y datos, con tope de 4 s. Pase lo que pase, se va al pago:
          // si algo no se guardó, Flow lo marca en el pedido. Nunca se queda trabado.
          e.preventDefault();
          e.stopImmediatePropagation();
          var submitter = e.submitter;
          clearTimeout(revisarTimer); revisarTimer = null;
          if (!S.dirty && !S.saving) S.dirty = true; // había una revisión pendiente: se hace ahora
          marcarGuardando(true);
          Promise.race([flush(el), espera(4000)]).then(function () {
            S.dirty = false;
            enviar(form, submitter);
          });
        }
      }, true);
    });
  }
  // Al regresar con "atrás" desde el checkout, el botón vuelve a la normalidad.
  window.addEventListener('pageshow', function () {
    marcarGuardando(false);
    FORM_IDS.forEach(function (id) { var f = document.getElementById(id); if (f) f.dataset.kdEnviando = ''; });
  });

  /* ======================================================================
     <kong-domicilio> — carrito
     ====================================================================== */
  class KongDomicilio extends HTMLElement {
    connectedCallback() {
      this.cfg = cfgOf(this);
      if (!this.cfg.on) return;
      this.total = (+this.getAttribute('data-total') || 0) / 100;
      if (!S.hydrated) {
        S.hydrated = true;
        var a = {};
        try { a = JSON.parse(this.getAttribute('data-attrs') || '{}') || {}; } catch (e) {}
        S.cp = a[ATTR.cp] || ls.get('kd:cp') || null;
        S.slot = a[ATTR.slot] || null;
        S.recibe = a[ATTR.recibe] || '';
        S.cel = a[ATTR.cel] || '';
        S.ref = a[ATTR.ref] || '';
        S.col = (a[ATTR.col] || '').replace(/ \(no verificada\)$/, '');
        S.colCp = null;
        S.mode = a[ATTR.entrega] ? 'domicilio' : (ls.get('kd:mode') || null);
      }
      var self = this;
      cargarZonas(this.cfg.zonas).then(function (Z) { self.Z = Z; self.render(); }).catch(function () {
        self.innerHTML = '';
        sincronizarBotones(false, null, self);
      });
      protegerFormularios();
    }

    contexto() {
      var Z = this.Z;
      var info = S.cp && cpValido(S.cp) ? buscarCP(Z, S.cp) : null;
      var enZona = !!info && info.zona !== 'nacional';
      var faltan = Math.max(0, Z.minimo - this.total);
      var elegible = enZona && faltan === 0;
      var ag = elegible ? agenda(this.cfg) : [];
      if (elegible && S.slot && !ag.some(function (d) { return d.slots.some(function (s) { return s.key === S.slot; }); })) {
        S.slot = null; S.dirty = true; // el horario guardado ya pasó
      }
      var coh = enZona ? coherencia(Z, S.cp, S.col, S.colCp) : { estado: 'sin' };
      var colOk = coh.estado === 'ok' || coh.estado === 'libre';
      var completo = elegible && colOk && !!S.slot && S.recibe.trim().length >= 3 && celValido(S.cel);
      // Para pagar hay que elegir cómo lo recibe; si es domicilio, CP válido y (si aplica) colonia + horario + quién recibe.
      var bloqueo = !S.mode || (S.mode === 'domicilio' && (!info || (elegible && ag.length > 0 && !completo)));
      return { Z: Z, info: info, enZona: enZona, faltan: faltan, elegible: elegible && ag.length > 0, sinHorario: elegible && !ag.length, agenda: ag, completo: completo, bloqueo: bloqueo, coh: coh };
    }

    render() {
      var c = this._ctx = this.contexto();
      var Z = c.Z, mode = S.mode;
      var precio = c.info && c.enZona ? precioZona(Z, c.info.zona) : null;
      var tabs = [
        ['domicilio', '🛵', 'Domicilio', c.info && c.enZona ? (c.info.zona === 'gratis' ? 'Gratis' : money(precio)) : 'Cuernavaca'],
        ['nacional', '📦', 'Paquetería', 'todo México'],
        ['recoger', '🏪', 'Recoger', 'listo en 1 h']
      ];
      var step = function (n, t, done) {
        return '<p class="kd-step' + (done ? ' is-done' : '') + '"><span class="kd-step__n" aria-hidden="true">' + (done ? '✓' : n) + '</span>' + t + '</p>';
      };
      var h = '<div class="kd-card">';
      h += '<p class="kd-eyebrow">¿Cómo lo recibes?</p><div class="kd-tabs" role="tablist">';
      tabs.forEach(function (t) {
        h += '<button type="button" role="tab" class="kd-tab' + (mode === t[0] ? ' is-on' : '') + '" aria-selected="' + (mode === t[0]) + '" data-mode="' + t[0] + '"><span class="kd-tab__ico" aria-hidden="true">' + t[1] + '</span><span class="kd-tab__t">' + t[2] + '</span><span class="kd-tab__s">' + t[3] + '</span></button>';
      });
      h += '</div>';

      if (mode === 'domicilio') {
        var cpOk = !!(S.cp && cpValido(S.cp));
        var dirOk = cpOk && c.enZona && c.coh && (c.coh.estado === 'ok' || c.coh.estado === 'libre');
        var cuandoOk = c.elegible && !!S.slot;
        var quienOk = S.recibe.trim().length >= 3 && celValido(S.cel);

        h += '<div class="kd-block">' + step(1, '¿A dónde te lo llevamos?', dirOk);
        h += '<div class="kd-row"><label class="kd-field kd-field--cp"><span>Código postal</span><input inputmode="numeric" autocomplete="postal-code" maxlength="5" pattern="[0-9]{5}" placeholder="62230" value="' + esc(S.cp || '') + '" data-in="cp"></label>';
        h += '<button type="button" class="kd-gps" data-gps><span aria-hidden="true">📍</span> Ubicarme</button></div>';
        h += '<p class="kd-gpsmsg" data-gpsmsg hidden></p>';
        if (cpOk && c.enZona) {
          h += '<div class="kd-colwrap"><label class="kd-field"><span>Colonia</span><input autocomplete="off" maxlength="80" placeholder="Escribe tu colonia" value="' + esc(S.col) + '" data-in="col" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="kd-sug"></label>';
          h += '<div class="kd-sug" id="kd-sug" data-sug role="listbox" hidden></div></div>';
          h += this.htmlCoherencia(c);
        }
        if (!cpOk) {
          h += '<p class="kd-note">Escribe tu CP y te decimos si te llega <b>GRATIS</b> hoy mismo.</p>';
        } else if (!c.enZona) {
          h += '<div class="kd-res kd-res--out"><span class="kd-res__txt"><b>Al CP ' + esc(S.cp) + ' no llega el domicilio.</b><small>Elige Paquetería (' + money(Z.nacional) + ', gratis desde ' + money(Z.nacionalGratisDesde) + ') o recoge en tienda.</small></span></div>';
        } else if (c.faltan > 0) {
          var pct = Math.min(100, Math.round(this.total / Z.minimo * 100));
          h += '<div class="kd-res kd-res--' + c.info.zona + '"><span class="kd-res__price">' + (c.info.zona === 'gratis' ? 'GRATIS' : money(precio)) + '</span><span class="kd-res__txt">Domicilio desde ' + money(Z.minimo) + '<small>Te faltan <b>' + money(c.faltan) + '</b> para pedirlo.</small></span></div>';
          h += '<div class="kd-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span class="kd-bar__fill" style="width:' + pct + '%"></span></div>';
        } else if (c.coh && c.coh.estado === 'choque') {
          // el aviso de CP/colonia ya está arriba
        } else if (c.sinHorario) {
          h += '<div class="kd-res kd-res--out"><span class="kd-res__txt"><b>Por ahora no hay entregas a domicilio.</b><small>Elige Paquetería o recoge en tienda.</small></span></div>';
        } else {
          h += '<div class="kd-res kd-res--' + c.info.zona + '"><span class="kd-res__price">' + (c.info.zona === 'gratis' ? 'GRATIS' : money(precio)) + '</span><span class="kd-res__txt"><span>Te llega a <b>' + esc(S.col.trim() ? S.col.trim() : 'CP ' + S.cp + (municipioDe(Z, S.cp) ? ', ' + municipioDe(Z, S.cp) : '')) + '</b></span><small>En Uber Moto, con link de seguimiento.</small></span></div>';
        }
        h += '</div>';

        if (c.elegible && !(c.coh && c.coh.estado === 'choque')) {
          // ② Cuándo
          var diaSel = null;
          c.agenda.forEach(function (d) { if (d.slots.some(function (s) { return s.key === S.slot; })) diaSel = d.key; });
          var diaActivo = this._dia && c.agenda.some(function (d) { return d.key === this._dia; }, this) ? this._dia : (diaSel || c.agenda[0].key);
          this._dia = diaActivo;
          h += '<div class="kd-block">' + step(2, '¿Cuándo te llega?', cuandoOk);
          h += '<div class="kd-days" data-days>';
          c.agenda.forEach(function (d) {
            h += '<button type="button" class="kd-day' + (d.key === diaActivo ? ' is-on' : '') + (d.key === diaSel ? ' has-slot' : '') + '" data-day="' + d.key + '">' + d.label + '</button>';
          });
          h += '</div><div class="kd-slotwrap" data-slots>';
          // "En la mañana" para no confundir con el día "Mañana".
          var grupos = [['En la mañana', 0, 720], ['En la tarde', 720, 1140], ['En la noche', 1140, 1e9]];
          c.agenda.forEach(function (d) {
            if (d.key !== diaActivo) return;
            grupos.forEach(function (g) {
              var ss = d.slots.filter(function (s) { return s.desde >= g[1] && s.desde < g[2]; });
              if (!ss.length) return;
              h += '<p class="kd-sub">' + g[0] + '</p><div class="kd-slots">';
              ss.forEach(function (s) {
                h += '<button type="button" class="kd-slot' + (s.key === S.slot ? ' is-on' : '') + '" data-slot="' + s.key + '" aria-label="Llega entre ' + s.texto + '">' + horaCorta(s.desde) + '–' + horaCorta(s.hasta) + '</button>';
              });
              h += '</div>';
            });
          });
          h += '</div></div>';

          // ③ Quién recibe
          h += '<div class="kd-block">' + step(3, '¿Quién lo recibe?', quienOk);
          h += '<div class="kd-grid"><label class="kd-field"><span>Nombre</span><input autocomplete="name" maxlength="60" placeholder="Nombre y apellido" value="' + esc(S.recibe) + '" data-in="recibe"></label>';
          h += '<label class="kd-field"><span>Celular</span><input type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="14" placeholder="10 dígitos" value="' + esc(S.cel) + '" data-in="cel"></label></div>';
          h += '<label class="kd-field"><span>Referencias <i>(opcional)</i></span><input maxlength="140" placeholder="Portón negro, entre calles…" value="' + esc(S.ref) + '" data-in="ref"></label>';
          h += '</div>';

          h += '<p class="kd-tip"><span aria-hidden="true">💡</span><span>Al pagar elige <b>Entrega local</b> con el CP <b>' + esc(S.cp) + '</b>.</span></p>';
          h += '<details class="kd-more"' + (this._more ? ' open' : '') + ' data-more><summary>¿Cómo funciona el domicilio?</summary><ul>';
          h += '<li>Lo mandamos en Uber Moto y te enviamos el link de seguimiento por WhatsApp al salir.</li>';
          h += '<li>Usa la misma dirección al pagar. Si el CP no corresponde a tu colonia, te avisamos y se ajusta el envío antes de mandarlo.</li>';
          h += '<li>Pedido mínimo ' + money(Z.minimo) + '. Gratis en Cuernavaca; ' + money(Z.precio50) + ' en zonas cercanas.</li>';
          h += '</ul></details>';
        }
      } else if (mode === 'nacional') {
        var falta = Math.max(0, Z.nacionalGratisDesde - this.total);
        h += '<div class="kd-res kd-res--nac"><span class="kd-res__price">' + (falta === 0 ? 'GRATIS' : money(Z.nacional)) + '</span><span class="kd-res__txt">Envío Express a todo México<small>' + (falta > 0 ? 'Gratis desde ' + money(Z.nacionalGratisDesde) + ': te faltan ' + money(falta) + '. ' : '') + 'Lo eliges al pagar.</small></span></div>';
      } else if (mode === 'recoger') {
        h += '<div class="kd-res kd-res--nac"><span class="kd-res__price">$0</span><span class="kd-res__txt">Recoger en tienda<small>Listo en 1 hora en ' + esc(Z.tienda.direccion) + '. Elige "Retiro" al pagar.</small></span></div>';
      } else {
        h += '<p class="kd-note kd-note--pick">👆 Elige una opción para continuar.</p>';
      }
      h += '<p class="kd-miss" data-miss role="alert" hidden></p>';
      h += '</div>';
      this.innerHTML = h;
      this._cohRender = c.coh && c.coh.estado;
      this.bind();
      var more = this.querySelector('[data-more]'), self = this;
      if (more) more.addEventListener('toggle', function () { self._more = more.open; });
      var activo = this.querySelector('.kd-day.is-on');
      if (activo && activo.scrollIntoView && this._diaScroll !== this._dia) {
        this._diaScroll = this._dia;
        var cont = this.querySelector('[data-days]');
        if (cont) cont.scrollLeft = Math.max(0, activo.offsetLeft - cont.offsetLeft - 16);
      }
      sincronizarBotones(c.bloqueo, c, this);
      if (S.dirty) programarGuardado(this);
      else programarRevision(this);
    }

    htmlCoherencia(c) {
      var Z = c.Z, coh = c.coh, h = '';
      if (coh.estado === 'choque') {
        var munCp = municipioDe(Z, S.cp) || 'otra zona';
        if (coh.opciones.length === 1) {
          var o = coh.opciones[0];
          h += '<div class="kd-warn" role="alert"><b>Ojo: tu código postal no coincide.</b> ' + (munCp === o.mun
            ? '<b>' + esc(o.nombre) + '</b> no tiene el CP ' + esc(S.cp) + ': su CP es <b>' + o.cp + '</b> (' + esc(o.mun) + ').'
            : 'El CP ' + esc(S.cp) + ' es de <b>' + esc(munCp) + '</b>, pero <b>' + esc(o.nombre) + '</b> es de <b>' + esc(o.mun) + '</b> (CP ' + o.cp + ').') + ' Ahí ' + textoZona(Z, o.zona) + '.';
          h += '<button type="button" class="kd-warn__btn" data-usecp="' + o.cp + '" data-usecol="' + esc(o.nombre) + '">Usar CP ' + o.cp + '</button></div>';
        } else {
          h += '<div class="kd-warn" role="alert"><b>Ojo:</b> no hay ninguna colonia <b>' + esc(S.col) + '</b> con CP ' + esc(S.cp) + ' (' + esc(munCp) + '). ¿Cuál es la tuya?<span class="kd-warn__opts">';
          coh.opciones.forEach(function (o) {
            h += '<button type="button" class="kd-warn__btn" data-usecp="' + o.cp + '" data-usecol="' + esc(o.nombre) + '">' + esc(o.mun) + ' · CP ' + o.cp + ' · ' + (o.zona === 'gratis' ? 'GRATIS' : o.zona === 'z50' ? money(Z.precio50) : 'Nacional') + '</button>';
          });
          h += '</span></div>';
        }
      } else if (coh.estado === 'libre') {
        h += '<p class="kd-note">No encontramos esa colonia en nuestro mapa; la confirmamos contigo por WhatsApp.</p>';
      }
      return h;
    }

    elegirColonia(nombre, cp) {
      S.col = nombre; S.colCp = cp; S.dirty = true;
      this.render();
    }

    sugerir(inp) {
      var self = this, box = this.querySelector('[data-sug]');
      if (!box) return;
      var lista = buscarColonias(this.Z, inp.value, S.cp);
      if (!lista.length || (lista.length === 1 && norm(lista[0].nombre) === norm(inp.value) && lista[0].cp === S.cp)) {
        box.hidden = true; inp.setAttribute('aria-expanded', 'false'); box.innerHTML = ''; return;
      }
      box.innerHTML = lista.map(function (o, i) {
        var tag = o.zona === 'gratis' ? 'GRATIS' : o.zona === 'z50' ? money(self.Z.precio50) : 'Nacional';
        return '<button type="button" role="option" class="kd-sug__i' + (o.cp !== S.cp ? ' is-other' : '') + '" data-pick="' + i + '"><span>' + esc(o.nombre) + '</span><small>' + esc(o.mun) + ' · CP ' + o.cp + ' · ' + tag + '</small></button>';
      }).join('');
      box.hidden = false; inp.setAttribute('aria-expanded', 'true');
      box.querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('mousedown', function (e) { e.preventDefault(); });
        b.addEventListener('click', function () { var o = lista[+b.getAttribute('data-pick')]; self.elegirColonia(o.nombre, o.cp); });
      });
    }

    bind() {
      var self = this;
      this.querySelectorAll('[data-usecp]').forEach(function (b) {
        b.addEventListener('click', function () {
          S.cp = b.getAttribute('data-usecp'); ls.set('kd:cp', S.cp);
          S.col = b.getAttribute('data-usecol'); S.colCp = S.cp; S.slot = null; S.dirty = true;
          self.render();
        });
      });
      this.querySelectorAll('[data-mode]').forEach(function (b) {
        b.addEventListener('click', function () {
          S.mode = b.getAttribute('data-mode');
          ls.set('kd:mode', S.mode);
          S.dirty = true;
          self.render();
        });
      });
      this.querySelectorAll('[data-day]').forEach(function (b) {
        b.addEventListener('click', function () { self._dia = b.getAttribute('data-day'); self.render(); });
      });
      this.querySelectorAll('[data-slot]').forEach(function (b) {
        b.addEventListener('click', function () { S.slot = b.getAttribute('data-slot'); S.dirty = true; self.render(); });
      });
      this.querySelectorAll('[data-in]').forEach(function (inp) {
        var k = inp.getAttribute('data-in');
        inp.addEventListener('input', function () {
          if (k === 'cp') {
            var v = inp.value.replace(/\D/g, '').slice(0, 5);
            if (v !== inp.value) inp.value = v;
            if (v.length === 5 && v !== S.cp) {
              S.cp = v; ls.set('kd:cp', v); S.slot = null; S.dirty = true;
              var info = buscarCP(self.Z, v);
              if (info.zona !== 'nacional') S.mode = 'domicilio';
              self.render();
              var again = self.querySelector('[data-in="cp"]');
              if (again) { again.focus(); try { again.setSelectionRange(5, 5); } catch (e) {} }
            }
            return;
          }
          if (k === 'col') {
            S.col = inp.value; S.colCp = null;
            self.sugerir(inp);
          } else {
            S[k] = inp.value;
          }
          self._ctx = self.contexto();
          sincronizarBotones(self._ctx.bloqueo, self._ctx, self);
          inp.classList.remove('is-bad');
          programarGuardado(self);
        });
        inp.addEventListener('blur', function () {
          if (k === 'cel' && inp.value && !celValido(inp.value)) inp.classList.add('is-bad');
          if (k === 'col') {
            // Al salir del campo se revisa la colonia escrita a mano contra el CP.
            setTimeout(function () {
              if (!self.isConnected || self.contains(document.activeElement) && document.activeElement.hasAttribute('data-pick')) return;
              var coh = coherencia(self.Z, S.cp, S.col, S.colCp);
              if (coh.estado !== self._cohRender || coh.estado === 'choque') self.render();
              else { var box = self.querySelector('[data-sug]'); if (box) box.hidden = true; }
            }, 150);
          }
        });
      });
      var gps = this.querySelector('[data-gps]');
      if (gps) gps.addEventListener('click', function () { self.ubicar(); });
    }

    ubicar() {
      var self = this, msg = this.querySelector('[data-gpsmsg]');
      var decir = function (t) { if (msg) { msg.hidden = false; msg.innerHTML = t; } };
      if (!navigator.geolocation) { decir('Tu navegador no comparte ubicación. Escribe tu CP.'); return; }
      decir('Buscando tu ubicación…');
      navigator.geolocation.getCurrentPosition(function (pos) {
        var r = resolverUbicacion(self.Z, pos.coords.latitude, pos.coords.longitude);
        if (!r.cp) { decir('Estás a ' + r.kmTienda.toFixed(1) + ' km de la tienda, fuera de la zona de domicilio. Si crees que no, escribe tu CP.'); return; }
        var munYo = municipioDe(self.Z, r.cp), munCp = cpValido(S.cp) ? municipioDe(self.Z, S.cp) : null;
        if (munCp && munYo && munCp !== munYo) {
          decir('<b>Ojo:</b> tu ubicación está en <b>' + esc(munYo) + '</b> (' + esc(r.nombre) + ', CP ' + r.cp + '), pero el CP ' + esc(S.cp) + ' es de <b>' + esc(munCp) + '</b>. Ahí ' + textoZona(self.Z, zonaDe(self.Z, r.cp)) + '. <button type="button" class="kd-link" data-ok>Usar CP ' + r.cp + '</button>');
          var ok2 = self.querySelector('[data-ok]');
          if (ok2) ok2.addEventListener('click', function () { S.cp = r.cp; ls.set('kd:cp', r.cp); S.col = ''; S.colCp = null; S.slot = null; S.mode = 'domicilio'; S.dirty = true; self.render(); });
          return;
        }
        decir('¿Estás por <b>' + esc(r.nombre) + '</b>, CP <b>' + r.cp + '</b>? <button type="button" class="kd-link" data-ok>Sí, usarlo</button>');
        var ok = self.querySelector('[data-ok]');
        if (ok) ok.addEventListener('click', function () {
          S.cp = r.cp; ls.set('kd:cp', r.cp); S.slot = null; S.mode = 'domicilio'; S.dirty = true; self.render();
        });
      }, function () { decir('No pudimos usar tu ubicación. Escribe tu CP.'); }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
    }

    mostrarFaltantes() {
      var c = this._ctx || {};
      var f = faltantes(c);
      var m = this.querySelector('[data-miss]');
      var txt = !S.mode ? 'Antes de pagar, elige cómo lo recibes: domicilio, paquetería o recoger en tienda.'
        : f.length ? 'Para el domicilio falta: ' + f.join(', ') + '.' : '';
      if (m && txt) { m.hidden = false; m.textContent = txt; }
      // Lleva al primer campo que falta.
      var q = function (sel) { return this.querySelector(sel); }.bind(this);
      var obj = !S.mode ? q('.kd-tabs')
        : !(S.cp && cpValido(S.cp)) ? q('[data-in="cp"]')
        : c.coh && (c.coh.estado === 'sin' || c.coh.estado === 'choque') ? q('[data-in="col"]')
        : !S.slot ? (q('[data-slots]') || q('[data-days]'))
        : S.recibe.trim().length < 3 ? q('[data-in="recibe"]')
        : !celValido(S.cel) ? q('[data-in="cel"]') : null;
      obj = obj || m;
      if (!obj) return;
      if (obj.scrollIntoView) obj.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (obj.tagName === 'INPUT') setTimeout(function () { try { obj.focus({ preventScroll: true }); } catch (e) { obj.focus(); } }, 400);
      obj.classList.remove('kd-pulse');
      void obj.offsetWidth;
      obj.classList.add('kd-pulse');
      setTimeout(function () { obj.classList.remove('kd-pulse'); }, 1800);
    }
  }

  // GPS → CP más cercano (sin servicios externos). Si no hay CP de zona cerca, está fuera.
  function resolverUbicacion(Z, lat, lon) {
    var t = [Z.tienda.lat, Z.tienda.lon];
    var kmTienda = km(t, [lat, lon]);
    var n = cpMasCercano(Z, lat, lon);
    if (!n || n.d > 1.8) return { cp: null, kmTienda: kmTienda };
    var info = buscarCP(Z, n.cp);
    return { cp: n.cp, nombre: info.nombre, zona: info.zona, kmTienda: kmTienda };
  }

  /* ======================================================================
     <kong-radar-mini> — producto
     ====================================================================== */
  class KongRadarMini extends HTMLElement {
    connectedCallback() {
      this.cfg = cfgOf(this);
      if (!this.cfg.on || this._init) return;
      this._init = true;
      var self = this;
      cargarZonas(this.cfg.zonas).then(function (Z) { self.Z = Z; self.render(); }).catch(function () { self.hidden = true; });
    }
    render() {
      var Z = this.Z, cp = ls.get('kd:cp'), h;
      var link = this.cfg.page ? '<a class="kd-mini__more" href="' + esc(this.cfg.page) + '">Ver mapa</a>' : '';
      if (cpValido(cp)) {
        var info = buscarCP(Z, cp);
        if (info.zona === 'nacional') h = '<span class="kd-mini__ico" aria-hidden="true">📦</span><span>CP ' + cp + ' · Envío nacional ' + money(Z.nacional) + ' · gratis desde ' + money(Z.nacionalGratisDesde) + '</span>';
        else h = '<span class="kd-mini__ico" aria-hidden="true">🛵</span><span>CP ' + cp + ' · <b>' + (info.zona === 'gratis' ? 'Domicilio GRATIS' : 'Domicilio ' + money(Z.precio50)) + '</b> desde ' + money(Z.minimo) + ' · tú eliges el horario</span>';
        h += '<button type="button" class="kd-mini__chg" data-chg>Cambiar</button>' + link;
      } else {
        h = '<span class="kd-mini__ico" aria-hidden="true">🛵</span><span><b>Domicilio GRATIS en Cuernavaca</b> desde ' + money(Z.minimo) + '</span><button type="button" class="kd-mini__chg" data-chg>¿Me llega?</button>' + link;
      }
      this.innerHTML = '<div class="kd-mini__row">' + h + '</div><div class="kd-mini__form" hidden><input inputmode="numeric" maxlength="5" placeholder="Tu código postal" aria-label="Tu código postal"></div>';
      var self = this, form = this.querySelector('.kd-mini__form'), inp = form.querySelector('input');
      this.querySelector('[data-chg]').addEventListener('click', function () { form.hidden = false; inp.focus(); });
      inp.addEventListener('input', function () {
        inp.value = inp.value.replace(/\D/g, '').slice(0, 5);
        if (inp.value.length === 5) {
          ls.set('kd:cp', inp.value);
          if (S.hydrated && S.cp !== inp.value) { S.cp = inp.value; S.slot = null; S.mode = null; S.dirty = true; }
          self.render();
        }
      });
    }
  }

  /* ======================================================================
     <kong-radar> — página de envíos con mapa
     ====================================================================== */
  function cargarLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if (window.__kdLeaflet) return window.__kdLeaflet;
    window.__kdLeaflet = new Promise(function (ok, ko) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
      s.onload = function () { ok(window.L); };
      s.onerror = ko;
      document.head.appendChild(s);
    });
    return window.__kdLeaflet;
  }

  class KongRadar extends HTMLElement {
    connectedCallback() {
      this.cfg = cfgOf(this);
      if (this._init) return;
      this._init = true;
      var self = this;
      this.out = this.querySelector('[data-out]');
      this.inp = this.querySelector('[data-cp]');
      this.gps = this.querySelector('[data-gps]');
      cargarZonas(this.cfg.zonas).then(function (Z) {
        self.Z = Z;
        var cp = ls.get('kd:cp');
        if (cpValido(cp)) { self.inp.value = cp; self.mostrar(cp); }
        self.observarMapa();
      }).catch(function () { if (self.out) self.out.textContent = 'No pudimos cargar las zonas. Escríbenos por WhatsApp.'; });
      this.inp.addEventListener('input', function () {
        self.inp.value = self.inp.value.replace(/\D/g, '').slice(0, 5);
        if (self.inp.value.length === 5 && self.Z) { ls.set('kd:cp', self.inp.value); self.mostrar(self.inp.value); }
      });
      this.gps.addEventListener('click', function () { self.ubicar(); });
      var q = this.querySelector('[data-colq]'), box = this.querySelector('[data-rsug]');
      if (q && box) {
        q.addEventListener('input', function () {
          if (!self.Z) return;
          var lista = buscarColonias(self.Z, q.value, self.inp.value);
          if (!lista.length) { box.hidden = true; q.setAttribute('aria-expanded', 'false'); box.innerHTML = ''; return; }
          box.innerHTML = lista.map(function (o, i) {
            var tag = o.zona === 'gratis' ? 'GRATIS' : o.zona === 'z50' ? money(self.Z.precio50) : 'Nacional';
            return '<button type="button" role="option" class="kd-sug__i" data-pick="' + i + '"><span>' + esc(o.nombre) + '</span><small>' + esc(o.mun) + ' · CP ' + o.cp + ' · ' + tag + '</small></button>';
          }).join('');
          box.hidden = false; q.setAttribute('aria-expanded', 'true');
          box.querySelectorAll('[data-pick]').forEach(function (b) {
            b.addEventListener('click', function () {
              var o = lista[+b.getAttribute('data-pick')];
              var antes = self.inp.value;
              q.value = o.nombre; box.hidden = true; q.setAttribute('aria-expanded', 'false');
              self.inp.value = o.cp; ls.set('kd:cp', o.cp);
              var aviso = cpValido(antes) && antes !== o.cp && municipioDe(self.Z, antes) !== o.mun
                ? '<b>Ojo:</b> el CP ' + esc(antes) + ' que escribiste es de ' + esc(municipioDe(self.Z, antes) || 'otra zona') + ', pero <b>' + esc(o.nombre) + '</b> es de <b>' + esc(o.mun) + '</b>. Usamos el CP correcto:'
                : '<b>' + esc(o.nombre) + '</b>, ' + esc(o.mun) + ':';
              self.mostrar(o.cp, aviso);
            });
          });
        });
        q.addEventListener('blur', function () { setTimeout(function () { box.hidden = true; q.setAttribute('aria-expanded', 'false'); }, 200); });
      }
    }

    mostrar(cp, extra) {
      var Z = this.Z, info = buscarCP(Z, cp);
      var cards = this.querySelectorAll('[data-zone]');
      cards.forEach(function (c) { c.classList.toggle('is-match', c.getAttribute('data-zone') === info.zona); });
      var h;
      if (info.zona === 'gratis') h = '<span class="kd-pill">GRATIS</span> <b>CP ' + cp + ' · ' + esc(info.nombre) + '</b>: te llevamos tu pedido a domicilio sin costo desde ' + money(Z.minimo) + '. Tú eliges el horario en el carrito.';
      else if (info.zona === 'z50') h = '<span class="kd-pill kd-pill--50">' + money(Z.precio50) + '</span> <b>CP ' + cp + ' · ' + esc(info.nombre) + '</b>: domicilio por ' + money(Z.precio50) + ' en pedidos desde ' + money(Z.minimo) + '. Tú eliges el horario en el carrito.';
      else h = '<span class="kd-pill kd-pill--nac">NACIONAL</span> <b>CP ' + cp + (municipioDe(Z, cp) ? ' · ' + esc(municipioDe(Z, cp)) : '') + '</b>: fuera de la zona de domicilio. Te llega por Envío Express Nacional (' + money(Z.nacional) + ', gratis desde ' + money(Z.nacionalGratisDesde) + ').';
      this.out.innerHTML = (extra ? extra + '<br>' : '') + h;
      this.out.hidden = false;
      if (this.map && info.lat != null) this.map.flyTo([info.lat, info.lon], 14, { duration: 0.8 });
    }

    ubicar() {
      var self = this;
      if (!navigator.geolocation) { this.out.hidden = false; this.out.textContent = 'Tu navegador no comparte ubicación. Escribe tu CP.'; return; }
      this.gps.classList.add('is-busy');
      navigator.geolocation.getCurrentPosition(function (pos) {
        self.gps.classList.remove('is-busy');
        var lat = pos.coords.latitude, lon = pos.coords.longitude;
        var r = resolverUbicacion(self.Z, lat, lon);
        self.ponerYo(lat, lon);
        if (!r.cp) {
          self.out.hidden = false;
          self.out.innerHTML = 'Estás a <b>' + r.kmTienda.toFixed(1) + ' km</b> de la tienda, fuera de la zona de domicilio: te llega por Envío Express Nacional (' + money(self.Z.nacional) + '). ¿Crees que sí estás en zona? Escribe tu CP.';
          return;
        }
        self.inp.value = r.cp;
        ls.set('kd:cp', r.cp);
        self.mostrar(r.cp, 'Estás a <b>' + r.kmTienda.toFixed(1) + ' km</b> de la tienda. Parece que tu CP es <b>' + r.cp + '</b>; si no, corrígelo arriba.');
      }, function () {
        self.gps.classList.remove('is-busy');
        self.out.hidden = false;
        self.out.textContent = 'No pudimos usar tu ubicación. Escribe tu CP.';
      }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
    }

    observarMapa() {
      var self = this, box = this.querySelector('[data-map]');
      if (!box) return;
      var go = function () { cargarLeaflet().then(function (L) { self.pintarMapa(L, box); }).catch(function () { box.classList.add('is-fail'); }); };
      if (!('IntersectionObserver' in window)) { go(); return; }
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '200px' });
      io.observe(box);
    }

    pintarMapa(L, box) {
      var Z = this.Z, t = [Z.tienda.lat, Z.tienda.lon];
      var map = this.map = L.map(box, { zoomControl: true, scrollWheelZoom: false, attributionControl: true }).setView(t, 12);
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18, className: 'kd-tiles',
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> · CP: GeoNames'
      }).addTo(map);
      var col = { 0: '#B8CC2A', 1: '#FFC93C' };
      Object.keys(Z.cp).forEach(function (cp) {
        var r = Z.cp[cp];
        if (r[1] == null) return;
        L.circle([r[1], r[2]], { radius: 650, stroke: false, fillColor: col[r[0]], fillOpacity: 0.22, interactive: true })
          .bindTooltip(cp + ' · ' + r[3] + ' · ' + (r[0] === 0 ? 'GRATIS' : money(Z.precio50)))
          .addTo(map);
      });
      var radar = L.divIcon({
        className: 'kd-radar-ico',
        html: '<span class="kd-radar-ico__sweep"></span><span class="kd-radar-ico__ring"></span><span class="kd-radar-ico__pin"><span class="kd-radar-ico__g" style="-webkit-mask-image:url(' + esc(this.cfg.pin || '') + ');mask-image:url(' + esc(this.cfg.pin || '') + ')"></span></span>',
        iconSize: [220, 220], iconAnchor: [110, 110]
      });
      L.marker(t, { icon: radar, interactive: false, keyboard: false }).addTo(map);
      L.marker(t, { opacity: 0 }).bindTooltip('KONG · ' + Z.tienda.direccion, { permanent: false }).addTo(map);
      if (this._yo) this.ponerYo(this._yo[0], this._yo[1]);
    }

    ponerYo(lat, lon) {
      this._yo = [lat, lon];
      if (!this.map || !window.L) return;
      if (this._yoM) this._yoM.remove();
      this._yoM = window.L.circleMarker([lat, lon], { radius: 8, color: '#fff', weight: 3, fillColor: '#3D9BFF', fillOpacity: 1 }).bindTooltip('Tú').addTo(this.map);
      this.map.flyTo([lat, lon], 13, { duration: 0.8 });
    }
  }

  if (!customElements.get('kong-domicilio')) customElements.define('kong-domicilio', KongDomicilio);
  if (!customElements.get('kong-radar-mini')) customElements.define('kong-radar-mini', KongRadarMini);
  if (!customElements.get('kong-radar')) customElements.define('kong-radar', KongRadar);

  // Expuesto para pruebas.
  window.KongDomicilio = { agenda: agenda, buscarCP: buscarCP, ahoraMx: ahoraMx, flush: flush, state: S };
})();
